import { Injectable } from "@angular/core";
import { MessageService } from "primeng/api";
import { MessageType } from "../enums/message-type.enum";

@Injectable({providedIn:'root'})
export class NotificationService {
  constructor(private messageService: MessageService) { }

  notify(message: string, type: MessageType) {
    switch (type) {
      case MessageType.Success:
        this.showSuccess(message);
        break;
      case MessageType.Info:
        this.showInfo(message);
        break;
      case MessageType.Warn:
        this.showWarn(message);
        break;
      case MessageType.Error:
        this.showError(message);
        break;
    }
  }

  showSuccess(message: string) {
    this.messageService.add({ severity: 'success', summary: 'Success', detail: message });
  }

  showInfo(message: string) {
    this.messageService.add({ severity: 'info', summary: 'Info', detail: message });
  }

  showWarn(message: string) {
    this.messageService.add({ severity: 'warn', summary: 'Warning', detail: message });
  }

  showError(message: string) {
    this.messageService.add({ severity: 'error', summary: 'Error', detail: message });
  }
}
